import React, { useState } from 'react';
import { X, Shield, Zap, CreditCard } from 'lucide-react';
import PaymentCrypto from './PaymentCrypto';
import PaymentPix from './PaymentPix';

const PaymentModal = ({ isOpen, onClose, amount = 1.99 }) => {
    const [method, setMethod] = useState(null); // 'crypto' | 'pix' | null

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
            <div className="bg-gray-900 border border-gray-800 rounded-3xl w-full max-w-lg overflow-hidden shadow-2xl">
                {/* Header */}
                <div className="p-6 border-b border-gray-800 flex justify-between items-center bg-gray-900/50">
                    <div>
                        <h2 className="text-xl font-bold text-white flex items-center gap-2">
                            <Zap className="text-yellow-400" size={20} />
                            Unlock Premium Report
                        </h2>
                        <p className="text-sm text-gray-400">Support the platform & get AI insights</p>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-gray-800 rounded-full text-gray-400 transition-colors">
                        <X size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6">
                    {!method ? (
                        <div className="space-y-4">
                            <p className="text-center text-gray-300 mb-6">
                                Single Evaluation: <span className="text-2xl font-bold text-white">${amount}</span>
                            </p>

                            <button
                                onClick={() => setMethod('crypto')}
                                className="w-full p-4 rounded-2xl bg-gradient-to-r from-indigo-600/20 to-purple-600/20 border border-indigo-500/30 hover:border-indigo-500 transition-all group text-left"
                            >
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 rounded-xl bg-indigo-500 flex items-center justify-center">
                                        <Shield className="text-white" size={24} />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-white">Pay with Crypto</h3>
                                        <p className="text-xs text-indigo-300">Polygon (USDC, USDT, MATIC)</p>
                                    </div>
                                    <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                                        <Zap size={16} className="text-indigo-400" />
                                    </div>
                                </div>
                            </button>

                            <button
                                onClick={() => setMethod('pix')}
                                className="w-full p-4 rounded-2xl bg-gradient-to-r from-green-600/20 to-teal-600/20 border border-green-500/30 hover:border-green-500 transition-all group text-left"
                            >
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 rounded-xl bg-green-500 flex items-center justify-center text-white font-bold text-xl italic">
                                        <CreditCard size={24} />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-white">Pagar com PIX</h3>
                                        <p className="text-xs text-green-300">Instantâneo para brasileiros 🇧🇷</p>
                                    </div>
                                    <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                                        <Zap size={16} className="text-green-400" />
                                    </div>
                                </div>
                            </button>
                        </div>
                    ) : (
                        <div className="animate-in slide-in-from-right-4 duration-300">
                            <button
                                onClick={() => setMethod(null)}
                                className="mb-4 text-xs text-gray-500 hover:text-white flex items-center gap-1 transition-colors"
                            >
                                ← Back to methods
                            </button>

                            {method === 'crypto' && <PaymentCrypto amount={amount} onSuccess={onClose} />}
                            {method === 'pix' && <PaymentPix amount={amount} onSuccess={onClose} />}
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="p-4 bg-gray-950/50 border-t border-gray-800 text-center">
                    <p className="text-[10px] text-gray-500 uppercase tracking-widest font-medium">
                        with Grok services · Deus no centro
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PaymentModal;
